import type { API } from 'chessboard/api/config/types';
import type { Game } from 'chessboard/model/game/types';
import { getExtendedNode } from 'chessboard/model/game/get-extended-node';

/**
 * Create the getNodeByIds method.
 */
export function createGetNodeByIds(context: API.Context) {
  /**
   * Get a node by ids.
   */
  return function getNodeByIds(ids: Game.Node.Model): Game.Move.Node | null {
    const { api, game } = context;

    const line = api.getRawLines()[ids.line];

    if (!line || ids.move === -1) {
      return null;
    }

    return getExtendedNode({
      move: line[ids.move],
      startingMoveNumber: game.startingMoveNumber(),
    });
  };
}
